import { BookingForm } from "~/components/admin/bookings";

export function ScreenNewBooking() {
  return <BookingForm />;
}

// export function ScreenNewBooking() {
//   return (
//     <CreateBookingProvider>
//       <BookingForm />
//       <CreateTickets />
//     </CreateBookingProvider>
//   );
// }
